import { LIVE } from '../../lib/queryPresets';

/** Listes parapheur (À signer / Mes envois) : pas de Realtime table → LIVE. */
export const PARAPHEUR_LIST_QUERY = LIVE;

/** Circuit ouvert chez l’autre : même poll, stale plus court que LIVE. */
export const PARAPHEUR_CIRCUIT_QUERY = {
  ...LIVE,
  staleTime: 10_000,
} as const;
